import type { Template } from '../types/templates.types';

/**
 * Returns the "create document from template" route for a template.
 * Fixed-DOCX templates use the DOCX fill flow; everything else uses the
 * classic generate route (honouring an explicit `href` when present).
 */
export const getCreateHref = (template: Template): string =>
  template.kind === 'fixed_docx'
    ? `/templates/${template.slug}/generate-docx`
    : (template.href ?? `/templates/${template.slug}/generate`);
